import {
	Button,
	Checkbox,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@dune/ui";
import React, { useState } from "react";
import { useLiftReserves } from "../../../../api/mutations/propositions.mutations";

interface LiftReservesModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	propositionId: number;
	currentReserves: string[];
}

export const LiftReservesModal: React.FC<LiftReservesModalProps> = ({
	open,
	onOpenChange,
	propositionId,
	currentReserves,
}) => {
	const [selectedReserves, setSelectedReserves] = useState<string[]>([]);
	const liftReservesMutation = useLiftReserves();

	const handleReserveToggle = (reserve: string) => {
		setSelectedReserves((prev) =>
			prev.includes(reserve)
				? prev.filter((r) => r !== reserve)
				: [...prev, reserve],
		);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (selectedReserves.length === 0) return;

		try {
			await liftReservesMutation.mutateAsync({
				propositionId,
				reservesToLift: selectedReserves,
			});
			onOpenChange(false);
			setSelectedReserves([]);
		} catch (error) {
			console.error("Erreur lors de la levée des réserves:", error);
		}
	};

	const handleClose = () => {
		if (!liftReservesMutation.isPending) {
			setSelectedReserves([]);
			onOpenChange(false);
		}
	};

	return (
		<Dialog open={open} onOpenChange={handleClose}>
			<DialogContent className="sm:max-w-[600px]">
				<DialogHeader>
					<DialogTitle>Lever les réserves</DialogTitle>
					<DialogDescription>
						Sélectionnez les réserves que vous souhaitez lever :
					</DialogDescription>
				</DialogHeader>

				<form onSubmit={handleSubmit} className="space-y-4">
					<div className="space-y-3">
						{currentReserves.map((reserve) => (
							<div key={reserve} className="flex items-center space-x-3">
								<Checkbox
									id={`reserve-${reserve}`}
									checked={selectedReserves.includes(reserve)}
									onCheckedChange={() => handleReserveToggle(reserve)}
								/>
								<label
									htmlFor={`reserve-${reserve}`}
									className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
								>
									{reserve}
								</label>
							</div>
						))}
					</div>

					<DialogFooter>
						<Button
							type="button"
							variant="outline"
							onClick={handleClose}
							disabled={liftReservesMutation.isPending}
						>
							Annuler
						</Button>
						<Button
							type="submit"
							disabled={
								selectedReserves.length === 0 || liftReservesMutation.isPending
							}
							isLoading={liftReservesMutation.isPending}
						>
							Lever les réserves
						</Button>
					</DialogFooter>
				</form>
			</DialogContent>
		</Dialog>
	);
};
